// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Tos = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.144 83.474h33.662v-9.996c0-4.026 3.3-7.302 7.354-7.302h9.997V15.854c0-1.85-1.482-3.355-3.302-3.355h-47.71c-1.821 0-3.303 1.505-3.303 3.355v64.264c0 1.85 1.482 3.356 3.302 3.356Zm37.66-2.773L72.33 70.175h-7.17c-1.85 0-3.356 1.482-3.356 3.303V80.7ZM78.9 69.135c-.027.05-.048.102-.081.15-.073.11-.157.213-.25.305L61.245 86.914a1.99 1.99 0 0 1-1.414.586 1.96 1.96 0 0 1-.285-.027H24.144c-4.025 0-7.3-3.3-7.3-7.355V15.855c0-4.056 3.275-7.355 7.3-7.355h47.71c4.027 0 7.302 3.299 7.302 7.354v52.322c0 .13-.014.263-.04.391-.011.06-.034.115-.052.173-.018.067-.034.135-.06.2-.03.068-.069.131-.105.195ZM63.633 59.078a2 2 0 0 0 0-3.999H33.14a1.999 1.999 0 1 0 0 3.999h30.492ZM33.14 44.53h30.492a2 2 0 0 0 0-3.999H33.14a2 2 0 0 0 0 3.999Zm-2-16.546a2 2 0 0 1 2-1.999h30.492a2 2 0 0 1 0 3.999H33.14c-1.104 0-2-.895-2-2Z"
			fill="#fff"
		/>
	</svg>
);
export default Tos;
